import { GetLocalDelegacao, GetLocalUserInfo, SetLocalUserInfo } from '@/localStorage'
import router from '@/router'
import { AUTORIZAR, CARREGAR_INFOS, LOGOUT_USER, OBTER_ACESSOS, PERMITIDO, SET_USER, USER_INFO } from './mutations-type'

export default {
  [SET_USER](state, user) {
    state.user = user
  },
  [LOGOUT_USER](state) {
    state.user = null
  },

  [USER_INFO](state, payload) {
    if (payload.ativo === false) {
      state.userInfo = null
    }

    state.userInfo = payload
    SetLocalUserInfo(state.userInfo)
  },

  async [AUTORIZAR](state) {
    const usuario = state.userInfo

    if (usuario != null && usuario.ativo) {
      if (!state.permissao) {
        await router.push('/nao-autorizado')
      }
    } else {
      await router.push('/nao-autorizado')
    }

    SetLocalUserInfo(usuario)
  },

  [PERMITIDO](state, recurso) {
    let usuario = GetLocalUserInfo()

    if (usuario.grupos != null) {
      let permissao

      if (usuario.grupos[0].permissoes.indexOf('799-3') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',799'
      }
      if (usuario.grupos[0].permissoes.indexOf('792-3') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',792'
      }

      if (usuario.grupos[0].permissoes.indexOf('801-1-4') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',801'
      }

      if (usuario.grupos[0].permissoes.indexOf('802-1-4') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',802'
      }
      if (usuario.grupos[0].permissoes.indexOf('803-1-4') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',803'
      }
      if (usuario.grupos[0].permissoes.indexOf('804-1-4') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',804'
      }
      if (usuario.grupos[0].permissoes.indexOf('789-0-1') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',789'
      }

      permissao = usuario.grupos[0].permissoes
        .trim()
        .split(',')
        .find((element) => element == recurso)

      if (permissao) {
        state.permissao = true

        return
      }
      state.permissao = false
    } else {
      router.push('/nao-autorizado')
    }
  },

  [CARREGAR_INFOS](state, store) {
    let userInfo = GetLocalUserInfo()
    if (userInfo != undefined) {
      let dados = {
        logotipo: 'https://cdn1.lg.com.br/autoatendimento/3.1.0/img/logotipo.png',
        nomePortal: `Categoria C ${process.env.VUE_APP_VERSAO} ${process.env.VUE_APP_AMBIENTE != 'PROD' ? ' - ' + process.env.VUE_APP_AMBIENTE : ''}`,
        usuario: {
          nome: userInfo.nome.toUpperCase(),
          foto: 'https://as2.ftcdn.net/jpg/03/46/93/61/220_F_346936114_RaxE6OQogebgAWTalE1myseY1Hbb5qPM.jpg',
          cargo: `(${userInfo.cargo.codigo}) ${userInfo.cargo.descricao.toUpperCase()}`,
          menus: [
            // {
            //   codigo: "12",
            //   descricao: "Minhas Informações",
            //   icone: "pi pi-user",
            //   url: "AA/AAPortal/AlteracaoDeSenha",
            //   acao: 4,
            // },
            // {
            //   codigo: "1447",
            //   descricao: "Alterar Senha",
            //   icone: "fa fa-key",
            //   url: "AA/AAPortal/AlteracaoDeSenha",
            //   acao: 4,
            // },
            {
              codigo: '99999',
              descricao: 'sair',
              icone: 'fa fa-sign-out',
              url: '/home',
              uid: 1893484233,
              acao: 4
            }
          ]
        },
        menus: []
      }

      dados.menus = state.menus

      store.commit('layout/setDadosLayout', dados)
      store.dispatch('user/getUser', userInfo)
    }
  },
  [OBTER_ACESSOS](state) {
    const userInfo = GetLocalUserInfo()

    let menusGeral = state.menuGeral
    let menus = []

    let permissoes = []

    var delegacao = GetLocalDelegacao()

    if (delegacao && delegacao != undefined) {
      let grupo = _.find(userInfo.grupos, { gestorId: delegacao })
      console.log('grupo', grupo)

      if (grupo) {
        if (grupo.permissoes.indexOf('799-3') != -1) {
          //XGH
          grupo.permissoes += ',799'
        }
        if (grupo) {
          if (grupo.permissoes.indexOf('792-3') != -1) {
            //XGH
            grupo.permissoes += ',792'
          }

          if (grupo.permissoes.indexOf('801-1-4') != -1) {
            //XGH
            grupo.permissoes += ',801'
          }

          if (grupo.permissoes.indexOf('802-1-4') != -1) {
            //XGH
            grupo.permissoes += ',802'
          }

          if (grupo.permissoes.indexOf('803-1-4') != -1) {
            //XGH
            grupo.permissoes += ',803'
          }

          if (grupo.permissoes.indexOf('804-1-4') != -1) {
            //XGH
            grupo.permissoes += ',804'
          }

          if (grupo.permissoes.indexOf('789-0-1') != -1) {
            //XGH
            grupo.permissoes += ',789'
          }

          permissoes = grupo.permissoes.split(',')
        }
      }

      if (permissoes != null && permissoes.length == 0 && userInfo != null && userInfo.grupos != undefined && userInfo.grupos != null) {
        if (userInfo.grupos[0].permissoes.indexOf('799-3') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',799'
        }

        if (userInfo.grupos[0].permissoes.indexOf('792-3') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',792'
        }

        if (userInfo.grupos[0].permissoes.indexOf('801-1-4') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',801'
        }

        if (userInfo.grupos[0].permissoes.indexOf('802-1-4') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',802'
        }
        if (userInfo.grupos[0].permissoes.indexOf('803-1-4') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',803'
        }
        if (userInfo.grupos[0].permissoes.indexOf('804-1-4') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',804'
        }

        if (userInfo.grupos[0].permissoes.indexOf('789-0-1') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',789'
        }

        permissoes = userInfo.grupos[0].permissoes.split(',')
      }

      permissoes = _.sortBy(permissoes)

      for (const permissao of permissoes) {
        let parents = permissao.split('-')

        if (parents.length == 1) {
          let registro = _.find(menusGeral, { codigo: parents[0] })

          if (registro) {
            let registroExiste = _.find(menus, { codigo: registro.codigo })

            if (!registroExiste) {
              menus.push(registro)
            }
          }
        }

        if (parents.length == 2) {
          let pai = _.find(menusGeral, { codigo: parents[0] })

          if (pai && pai.itens) {
            let itemMenu = _.find(pai.itens, { codigo: permissao })

            if (itemMenu) {
              let paiExiste = _.find(menus, { codigo: pai.codigo })

              if (!paiExiste) {
                let paiMenu = JSON.parse(JSON.stringify(pai))
                paiMenu.itens = []
                paiMenu.itens.push(itemMenu)
                menus.push(paiMenu)
              } else {
                let itemExiste = _.find(paiExiste.itens, {
                  codigo: itemMenu.codigo
                })

                if (!itemExiste) {
                  paiExiste.itens.push(itemMenu)
                }
              }
            }
          }
        }

        if (parents.length == 3) {
          console.log('avö', parents[0])

          let avo = _.find(menusGeral, { codigo: parents[0] })

          if (avo) {
            let pai = _.find(avo.itens, {
              codigo: `${parents[0]}-${parents[1]}`
            })

            if (pai) {
              let avoExiste = _.find(menus, { codigo: avo.codigo })

              if (!avoExiste) {
                let AvoMenu = JSON.parse(JSON.stringify(avo))
                AvoMenu.itens = []
                AvoMenu.itens.push(pai)
                menus.push(AvoMenu)
              } else {
                let paiExiste = _.find(avoExiste.itens, { codigo: pai.codigo })
                if (!paiExiste) {
                  avoExiste.itens.push(pai)
                }
              }
            }
          }
        }
      }

      menus = _.sortBy(menus, [
        function (o) {
          return o.descricao
        }
      ])

      state.menus = menus
    }
  }
}
